module.exports = __webpack_public_path__ + "static/media/todo.3c2e3aa6.gif";